import {
  faGauge,
  faGear,
  faShoppingBag,
  faBasketShopping,
  faChartLine,
  faMoneyBillWave,
  faUserTie,
  faBell,
  faUserCog,
  faKey,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";

export const ownerNavLinks = [
  {
    label: "Dashboard",
    href: "/shop",
    icon: faGauge,
    pageTitle: "Dashboard",
    // no permission → always visible
  },
  {
    label: "Manage products",
    href: "/shop/products",
    icon: faShoppingBag,
    pageTitle: "Manage Products",
    permission: ["manage_product", "read_product"],
  },
  {
    label: "Manage shops",
    href: "/shop/shops",
    icon: faBasketShopping,
    pageTitle: "Manage Shops",
    permission: ["manage_shop_modules", "manage_shop", "read_shop"],
  },
  {
    label: "Manage stock",
    href: "/shop/stocks",
    icon: faClipboardList,
    pageTitle: "Manage Stock",
    permission: ["manage_stock", "read_stock", "manage_shop_modules"],
  },
  {
    label: "Manage sales",
    href: "/shop/sales",
    icon: faChartLine,
    pageTitle: "Manage Sales",
    permission: ["manage_shop_modules", "manage_sales", "read_sales"],
  },
  {
    label: "Manage sellers",
    href: "/shop/sellers",
    icon: faUserTie,
    pageTitle: "Manage Sellers",
    permission: [
      "manage_shop_modules",
      "manage_business_seller",
      "read_business_seller",
    ],
  },
  {
    label: "Manage payment",
    href: "/shop/payment",
    icon: faMoneyBillWave,
    pageTitle: "Manage Payment",
    permission: ["manage_payment", "read_payment"],
  },
  {
    label: "Settings",
    icon: faGear,
    pageTitle: "Settings",
    children: [
      {
        label: "My profile",
        href: "/shop/profile",
        icon: faUserCog,
        pageTitle: "My Profile",
      },
      {
        label: "Change password",
        href: "/shop/changePassword",
        icon: faKey,
        pageTitle: "Change Password",
      },
      {
        label: "Notifications",
        href: "/shop/notification",
        icon: faBell,
        pageTitle: "System Notifications",
        permission: ["manage_notification", "read_notification"],
      },
    ],
  },
];

export function getPageTitle(pathname) {
  for (const link of ownerNavLinks) {
    if (link.children) {
      for (const child of link.children) {
        if (child.children) {
          for (const grandchild of child.children) {
            if (
              pathname === grandchild.href ||
              (grandchild.href && pathname.startsWith(grandchild.href))
            ) {
              return grandchild.label;
            }
          }
        }
        if (
          child.href &&
          (pathname === child.href || pathname.startsWith(child.href))
        ) {
          return child.pageTitle ?? child.label;
        }
      }
    }
    if (link.href && pathname === link.href) return link.pageTitle;
    if (link.href && link.href !== "/shop" && pathname.startsWith(link.href))
      return link.pageTitle;
  }
  return "Dashboard";
}
